import { deepFreeze } from 'utils/deepFreeze';
import type { QuickShopState } from '../types';

export const initialState: Readonly<QuickShopState> = deepFreeze({});
